'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Icon = require('../Icon');

var _Icon2 = _interopRequireDefault(_Icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*eslint-disable */
var Preview = function Preview(props) {
  return _react2.default.createElement(
    _Icon2.default,
    _extends({ viewBox: '0 0 12 12' }, props),
    _react2.default.createElement(
      'g',
      null,
      _react2.default.createElement(
        'title',
        null,
        'Combined Shape'
      ),
      _react2.default.createElement('path', { d: 'M8 0v1h2.293L5.646 5.647l.708.708L11 1.707V4h1V0H8zm3 10.2a.8.8 0 0 1-.8.8H1.8a.8.8 0 0 1-.8-.8V1.8a.8.8 0 0 1 .8-.8H6V0H1.8C.807 0 0 .807 0 1.8v8.4c0 .992.807 1.8 1.8 1.8h8.4c.993 0 1.8-.808 1.8-1.8V6h-1v4.2z',
        fill: 'currentColor', fillRule: 'evenodd' })
    )
  );
};
/*eslint-enable */

exports.default = Preview;
//# sourceMappingURL=Preview.js.map



// WEBPACK FOOTER //
// ./~/wix-style-react/dist/src/Icons/dist/components/Preview.js